import React from 'react';

import { centsToDollarsAndCents } from '@/helpers/currencyUtils/helper';
import { type PurchaseContext } from '@/types/purchaseContextToggle/types';

export const ShowPriceSavings = ({
  purchaseContext,
  priceDifference,
}: {
  purchaseContext: PurchaseContext;
  priceDifference: number;
}) => (
  <div className="cur-my-1 cur-font-bold cur-min-h-[34px] cur-text-surface-brand">
    {purchaseContext === 'subscription'
      ? `You're saving ${centsToDollarsAndCents(priceDifference)}!`
      : ''}
  </div>
);
